import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=0e7207bd&"
import script from "./upload.vue?vue&type=script&lang=ts&"
export * from "./upload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports